module.exports = __webpack_public_path__ + "static/images/monet/icon_stop.png";